<template>
  <v-dialog v-model="confirmOpen" :max-width="confirmMaxWidth">
    <v-card>
      <v-card-title>{{ confirmTitle }}</v-card-title>
      <v-card-text>{{ confirmMessage }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="rejectConfirm">{{ confirmCancelText }}</v-btn>
        <v-btn color="primary" variant="flat" @click="acceptConfirm">{{ confirmOkText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useAppModal } from '../composables/ui/useAppModal'

const {
  confirmOpen,
  confirmTitle,
  confirmMessage,
  confirmOkText,
  confirmCancelText,
  confirmMaxWidth,
  acceptConfirm,
  rejectConfirm,
} = useAppModal()
</script>
